import { useFormikContext, Field } from 'formik';
import React, { useEffect, useMemo } from 'react';
import { useQuery } from 'react-apollo';
import clubCodeQuery from './ClubCodeQuery.gql';
import t from 'format-message';
import { styled } from 'linaria/react';
import { parseKeyValuePairs } from '../../../utils/HelpFunctions';
import { SmallCaps } from '../../ui/Headings';

function getClubData(data) {
  const clubData = {};
  data?.forEach(item => {
    clubData[item.key] = item.value;
  });
  return clubData;
}

const ClubAccessFieldWrapper = styled('div')`
  margin-bottom: 2rem;

  select {
    font-family: 'Roboto';
    height: 35px;
    background: #fcfcfc;
    border: 1px solid #333333;
    font-weight: 400;
    font-size: 13px;
    padding: 0.5em 1em;
    width: 100%;
    margin-bottom: 10px;
    padding-right: 40px;
    border-radius: 0;
    line-height: 35px;
  }

  select:disabled {
    -webkit-appearance: none;
    -moz-appearance: none;
    border: none;
    background: none;
    color: black;
    padding: 0;
    font-size: 1rem;
  }
  .club-text {
    font-size: 12px;
  }
`;

export const ClubAccessField = ({ showTitle = true, preselected = false }) => {
  const { data, loading, error } = useQuery(clubCodeQuery);
  const { values, setFieldValue, errors } = useFormikContext();

  const clubListData = useMemo(() => {
    console.log({ data });
    if (loading || error) return null;
    return parseKeyValuePairs(
      data.category.data.items[0].properties[0].value.value
    ).filter(item => !item.value.startsWith('#'));
  }, [data, loading, error]);

  useEffect(() => {
    setFieldValue(
      'dynamicContent.club',
      getClubData(clubListData)[values.dynamicContent?.club_code]?.trim()
    );
    console.log(values);
  }, [values?.dynamicContent?.club_code]);
  if (loading || error) return null;
  console.log(clubListData);
  return (
    <ClubAccessFieldWrapper>
      <Field type="checkbox" name="preferences.type.acceptsEmail" />
      <Field type="checkbox" name="preferences.type.acceptsSms" />

      {showTitle && <SmallCaps>{t('Select your club')}</SmallCaps>}
      <Field name="dynamicContent.club_code" as="select">
        <option value=""></option>
        {clubListData.map((club, index) => (
          <option key={index} value={club.key}>
            {club.value}
          </option>
        ))}
      </Field>
      <div className="club-text">
        <p>
          {t(
            'Leave the field blank if you do not belong to a club that has a cooperation agreement with Torshov Sport.'
          )}
        </p>
      </div>
    </ClubAccessFieldWrapper>
  );
};
